import { Card } from "@components/cards/card";
import { ManagementTrackingList } from "@components/tracking/management-tracking-list";
import { FaArrowLeft, FaBoxOpen } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export const OrderTrackingsManagement = () => {
  const navigate = useNavigate();

  return (
    <div
      className="container-fluid d-flex flex-column justify-content-start align-items-center"
      style={{
        paddingBottom: "2.5rem",
        paddingTop: "clamp(1rem, 2vw, 2rem)",
        paddingLeft: "clamp(1rem, 5vw, 10rem)",
        paddingRight: "clamp(1rem, 5vw, 10rem)",
      }}
    >
      <div className="col-12">
        <Card className="shadow-sm rounded mb-4 border-0">
          <div className="card-body p-4">
            <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-3">
              <div className="d-flex align-items-center gap-3">
                <div className="rounded-3 d-inline-flex align-items-center justify-content-center p-3 bg-primary-subtle text-primary">
                  <FaBoxOpen size={30} />
                </div>

                <div>
                  <span className="badge rounded-pill text-bg-primary mb-2">
                    Gerenciamento
                  </span>
                  <h3 className="fw-bold mb-1">Rastreios de Pedidos</h3>
                  <p className="text-muted mb-0">
                    Consulte, filtre e exporte os rastreios vinculados aos
                    clientes da plataforma.
                  </p>
                </div>
              </div>

              <button
                type="button"
                className="btn btn-outline-secondary d-flex align-items-center gap-2"
                onClick={() => navigate("/management")}
              >
                <FaArrowLeft />
                Voltar
              </button>
            </div>
          </div>
        </Card>

        <ManagementTrackingList />
      </div>
    </div>
  );
};
